export const ALL_OPTIONS_ID = -1;

export const LIST_OPTIONS = [
  {
    value: 42,
    title: 'modalCourseComponent.languages.spanish'
  },
  {
    value: 41,
    title: 'modalCourseComponent.languages.english'
  },
  {
    value: ALL_OPTIONS_ID,
    title: 'modalCourseComponent.languages.both'
  }
];
